export enum TemperatureClass {
    HeatingTimeT3,
    HeatingTimeT1T2
}
